import registrationEvents from "./events/RegistrationEvents";
import * as _ from "lodash";
import MaskUtil from "core-ui/client/src/app/MaskUtil";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import AccessibilityUtil from "core-ui/client/src/app/core/util/AccessibilityUtil";
import dateUtil from "core-ui/client/src/app/DateUtil";
import idProofConsentTemplate from "../idProof/idProofConsentTemplate";
import IDProofConsentController from ".././idProof/IDProofConsentController";

var modalInstance;
var registrationController = function (
    $injector,
    $modal,
    $cookies,
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $timeout,
    $translate,
    AccuCodeService,
    AuthenticationStatusService,
    LogoutService,
    MenuNavigationFactory,
    SetACCUService,
    eventBus,
    redirectService,
    registrationFactory,
    PreLoginAccuRetrievalService
) {
    var vm = this;
    let previousSSN;
    let newSSN;
    let previousDateOfBirth;

    var logger = ExternalLogger.getInstance("registrationController");
    // eslint-disable-next-line no-undef
    $rootScope.iframeUrl = globalThis.iframeUrl;
    $scope.accountSetUp.fromLogin = false;
    $scope.ssnError = "";
    $scope.zipCodeError = "";
    ($scope.uniqueIdentifierError = ""), ($scope.planIDError = ""), ($scope.ssnLastNameError = "");
    $scope.ssnDateOfBirthError = "";
    $scope.uniqueidLastNameError = "";
    $scope.uniqueidDateOfBirthError = "";
    $scope.streetAddressError = "";
    $scope.autherizationMessage = "";
    $scope.autherizationMessageParams = "";
    $scope.areFieldsRequired = {
        ssnFields: true,
        uniqueidFields: true
    };
    $scope.individual = {
        identifierType: "ssn",
        ssn: "",
        zipCode: "",
        uniqueIdentifier: "",
        planID: "",
        ssnLastName: "",
        ssnDateOfBirth: "",
        uniqueidLastName: "",
        uniqueidDateOfBirth: "",
        streetAddress: "",
        pin: ""
    };

    // CODE BLOCK is for PART-45271
    if ($stateParams.featureName) $rootScope.featureName = $stateParams.featureName;

    extractErrorMessageFromRedirection(window.location.href);

    AuthenticationStatusService.getAuthData().then(function (data) {
        $scope.areFieldsRequired.ssnFields =
            !$rootScope.accuCustomization.showLoginSetupRecoveryRadio;
        $scope.areFieldsRequired.uniqueidFields =
            $rootScope.accuCustomization.showLoginSetupRecoveryRadio;
        $scope.individual.identifierType = checkIdentifierType();

        function propertyToBoolean(val) {
            var booleanState = ["false", "true"].indexOf(val);
            return booleanState >= 0 ? Boolean(booleanState) : val;
        }
        var authStatus = _.mapValues(data, propertyToBoolean);
        if (authStatus.authenticated) {
            LogoutService.logOutServices.query(function (data) {
                LogoutService.logOutPartAuth.query().$promise.then(
                    {},
                    function (data) {
                        console.log("part auth session invalidated");
                        $cookies.remove("JSESSIONID", { path: "/participant-web-services" });
                        $cookies.remove("JSESSIONID", { path: "/participant-authentication" });
                        $cookies.remove("site_tok", { path: "/participant" });
                        $cookies.remove("site_tok", { path: "/" });
                        $cookies.remove("X-CSRF-TOKEN", { path: "/" });
                        $cookies.remove("PM-INDID-TOKEN", { path: "/" });
                        $cookies.remove("PM-PLAN-TOKEN", { path: "/" });
                        // $cookies.remove('PM-ACCU-TOKEN', {path: '/'});
                    },
                    function (error) {
                        $cookies.remove("JSESSIONID", { path: "/participant-web-services" });
                        $cookies.remove("JSESSIONID", { path: "/participant-authentication" });
                        $cookies.remove("site_tok", { path: "/participant" });
                        $cookies.remove("site_tok", { path: "/" });
                        $cookies.remove("X-CSRF-TOKEN", { path: "/" });
                        $cookies.remove("PM-INDID-TOKEN", { path: "/" });
                        $cookies.remove("PM-PLAN-TOKEN", { path: "/" });
                        // $cookies.remove('PM-ACCU-TOKEN', {path: '/'});
                    }
                );
                MenuNavigationFactory.getAccu.query({}, function (code) {
                    //using image rather than $http due to redirects.
                    var tmpImg = new Image();
                    if (code[0] === $scope.accu) {
                        // eslint-disable-next-line no-undef
                        tmpImg.src = __iframeUrl__ + "/logoutNextgen.do?accu=" + $scope.accu;
                    } else {
                        // eslint-disable-next-line no-undef
                        tmpImg.src =
                            __iframeUrl__ +
                            "/logoutNextgen.do?accu=" +
                            code[0] +
                            "&overrideAccu=" +
                            $scope.accu;
                    }
                    $rootScope.$emit("loginAuthStatusVerified", $scope.authenticationStatus);
                });

                // Since the above logout is clearing out the PWS session with the accu codes which were being set originally when the page being loaded.

                var accuParam = AccuCodeService.getAccuCode();
                $scope.accu = accuParam;

                logger.info("accu is [{0}]", [accuParam]);

                /**SetACCUService.query({
                    accu: accuParam
                }).$promise.then(function(){
                    csrfTokenFactory.generateCSRF();
                });*/

                SetACCUService.query({ accu: accuParam }).$promise.then(function (data) {
                    //logger.info('setAccu call completed...[{0}]',[accuParam]);
                });
            });
        } else {
            $rootScope.$emit("loginAuthStatusVerified", $scope.authenticationStatus);
        }
    });
    $scope.content = {
        idProofingEnabled: $translate.instant("idProofing.enabled")
    };
    if (!$scope.content.idProofingEnabled) {
        $scope.content.idProofingEnabled = false;
    }
    $scope.includes = $state.includes;
    $scope.accordion = {
        isWithoutPinOpen: true,
        isWithPinOpen: true,
        isGroupOpen: true
    };
    $scope.goToTab = function (tab) {
        $state.go("registration." + tab);
    };
    $scope.registrationWithPin = true;
    $scope.registrationWithoutPin = true;
    $scope.registrationWithGroupPassword = true;
    $scope.loginURL = {
        URL: null,
        HEADER: null
    };

    if ($stateParams.hardStopError) {
        getLoginURL();
        $cookies.remove("accu", { path: "/participant" });
    }

    getDevice();

    $scope.accordion = {
        isWithoutPinOpen: true,
        isWithPinOpen: true,
        isGroupOpen: true
    };

    $scope.cleaveoptions = {
        ssn: {
            blocks: [3, 2, 4],
            delimiters: ["-"]
        }
    };
    /**
     * focus manager
     * indexed by fieldName
     * @type {{}}
     */
    $scope.focusMgr = {};
    function getLoginURL() {
        $scope.loginURL = redirectService.getLoginURL();
    }

    $scope.includeAcc = function (tabName) {
        // var include = includes(tabName);
        if (tabName === "register.withoutPin") {
            $scope.registrationWithoutPin = true;
            $scope.registrationWithPin = false;
        } else if (tabName === "register.withPin") {
            $scope.registrationWithoutPin = false;
            $scope.registrationWithPin = true;
        }
    };

    // function toggleRequiredFields(identifierType) {
    //     if (identifierType === "ssn") {
    //         $scope.areFieldsRequired.ssnFields = true;
    //         $scope.areFieldsRequired.uniqueidFields = false;
    //     }
    //     if (identifierType === "uniqueid") {
    //         $scope.areFieldsRequired.ssnFields = false;
    //         $scope.areFieldsRequired.uniqueidFields = true;
    //     }
    // }

    // $scope.onClickIdentifierType = function (event) {
    //     const identifierType = event.target.value;
    //     const ssnRadio = document.querySelector('input#hasSSN');
    //     const ssnPanel = document.querySelector('#collapseSSN');
    //     const uniqueIDRadio = document.querySelector('input#hasUniqueID');
    //     const uniqueIDPanel = document.querySelector('#collapseUniqueID');
    //     if (identifierType === "ssn") {
    //         ssnRadio.classList.remove("collapsed");
    //         ssnPanel.classList.add("in");
    //         uniqueIDRadio.classList.add("collapsed");
    //         uniqueIDPanel.classList.remove("in");
    //         $scope.individual.uniqueIdentifier = "";
    //         $scope.individual.planID = "";
    //         $scope.individual.uniqueidLastName = "";
    //         $scope.individual.uniqueidDateOfBirth = "";
    //     }
    //     if (identifierType === "uniqueid") {
    //         uniqueIDRadio.classList.remove("collapsed");
    //         uniqueIDPanel.classList.add("in");
    //         ssnRadio.classList.add("collapsed");
    //         ssnPanel.classList.remove("in");
    //         $scope.individual.ssn = "";
    //         $scope.individual.zipCode = "";
    //         $scope.individual.ssnLastName = "";
    //         $scope.individual.ssnDateOfBirth = "";
    //     }
    //     toggleRequiredFields(identifierType);
    // }

    $scope.fieldOnBlur = function (fieldName) {
        if (_.isUndefined($scope.registerForm)) {
            return "";
        }
        var field = $scope.registerForm[fieldName];
        var fieldFocused = $scope.focusMgr[fieldName] || false;
        var status = "";

        if (field.$touched && field.$invalid && !fieldFocused) {
            status = "has-error";
        }
        return status;
    };
    $scope.getFormGroupClass = function (fieldName) {
        var method = "getFormGroupClass(" + fieldName + ") ";
        if (_.isUndefined($scope.registerForm)) {
            return "";
        }
        var field = $scope.registerForm[fieldName];
        var fieldFocused = $scope.focusMgr[fieldName] || false;
        var status = "";

        if (field && field.$invalid && field.$dirty && !fieldFocused) {
            status = "has-error";
        }

        if (field && field.$valid && field.$dirty) {
            status = "has-success";
        }
        logger.debug("{0} returning [{1}]", [method, status]);
        return status;
    };
    $scope.isTouched = function (fieldName) {
        return $scope.registerForm[fieldName].$dirty;
    };
    $scope.isDirty = function (fieldName) {
        if (_.isUndefined($scope.registerForm)) {
            return false;
        }
        var dirty =
            $scope.registerForm[fieldName] !== undefined && $scope.registerForm[fieldName].$dirty;

        return dirty;
    };
    $scope.displayFieldMessages = function (fieldName, suppressFocused) {
        var method = "displayFieldMessages(" + fieldName + ") ";
        if (_.isUndefined(suppressFocused)) {
            suppressFocused = false;
        }

        if (_.isUndefined($scope.registerForm)) {
            return "";
        }
        var field = $scope.registerForm[fieldName];
        if (_.isUndefined($scope.registerForm) || !field) {
            return true;
        }
        var conditions =
            (field.$invalid && field.$dirty && !suppressFocused) ||
            (field.$touched && !suppressFocused) ||
            (!field.$pristine && !suppressFocused);
        var logData = {
            conditions: conditions,
            $invalid: field.$invalid,
            $dirty: field.$dirty,
            suppressFocused: suppressFocused,
            $touched: field.$touched,
            $pristine: field.$pristine
        };
        logger.debug("{0} response: {1}", [method, JSON.stringify(logData)]);
        return conditions;
    };
    $scope.getFieldError = function (fieldName) {
        var method = "getFieldError(" + fieldName + ") ";
        var rc = null;
        if (
            _.isUndefined($scope.registerForm) ||
            !fieldName ||
            _.isUndefined($scope.registerForm[fieldName])
        ) {
            logger.debug("getFieldError(" + fieldName + ") .. unknown field.");
            rc = "";
        } else {
            rc = $scope.registerForm[fieldName].$error;
        }
        logger.debug("{0} rc=[{1}]", [method, JSON.stringify(rc)]);
        return rc;
    };
    $scope.removeInputFocus = function (event) {
        //event.preventDefault();
        //event.stopPropagation();
        //event.stopImmediatePropagation();

        $timeout(function () {
            $scope.focusMgr[event.target.name] = false;
        });
    };

    $scope.setInputFocus = function (event) {
        //event.preventDefault();
        //event.stopPropagation();
        //event.stopImmediatePropagation();

        $scope.focusMgr[event.target.name] = true;
        $scope.registerForm[event.target.name].$setTouched(true);
        $scope.registerForm[event.target.name].$setDirty(true);
    };
    // **********
    function getDevice() {
        var isMobile = {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (
                    isMobile.Android() ||
                    isMobile.BlackBerry() ||
                    isMobile.iOS() ||
                    isMobile.Opera() ||
                    isMobile.Windows()
                );
            }
        };

        if (isMobile.any()) {
            $scope.mobileDevice = "true";
        } else {
            $scope.mobileDevice = "false";
        }
    }

    function registerFormIsValid() {
        if ($scope.individual.identifierType === "ssn") {
            return (
                $scope.registerForm.ssn.$valid &&
                $scope.registerForm.zipCode.$valid &&
                $scope.registerForm.ssnLastName.$valid &&
                $scope.registerForm.ssnDateOfBirth.$valid
            );
        }
        if ($scope.individual.identifierType === "uniqueid") {
            return (
                $scope.registerForm.uniqueIdentifier.$valid &&
                $scope.registerForm.planID.$valid &&
                $scope.registerForm.uniqueidLastName.$valid &&
                $scope.registerForm.uniqueidDateOfBirth.$valid
            );
        }
    }

    $scope.registerWithoutPin = function (flowName) {
        eventBus.dispatch(registrationEvents.SUBMIT_NO_PIN, this);
        $rootScope.flowName = flowName;
        $scope.individual.identifierType = checkIdentifierType(); // WCDX-9804 set identifierType to $rootscope value if the page is reloaded.

        if (registerFormIsValid()) {
            $scope.showSpinner = true;
            let registerData;
            var baseRegisterData = {
                flowName: flowName,
                isAppleSplash: $rootScope.appleSplash,
                isIDProofing: $scope.content.idProofingEnabled,
                accu: $cookies.get("accu")
            };
            if ($scope.individual.identifierType === "ssn") {
                registerData = {
                    lastName: $scope.individual.ssnLastName,
                    dateOfBirth: $scope.individual.ssnDateOfBirth,
                    ssn: newSSN,
                    zipcode: $scope.individual.zipCode,
                    ...baseRegisterData
                };
            }
            if ($scope.individual.identifierType === "uniqueid") {
                registerData = {
                    lastName: $scope.individual.uniqueidLastName,
                    dateOfBirth: $scope.individual.uniqueidDateOfBirth,
                    uniqueId: $scope.individual.uniqueIdentifier,
                    metrixPlanId: $scope.individual.planID,
                    ...baseRegisterData
                };
            }

            registrationFactory.registerWithoutPin.query(
                registerData,

                function (data, headers) {
                    $scope.showSpinner = false;
                    if (data.errors === false) {
                        if (data.state === "ID_PROOFING_CONSENT") {
                            openConsentModal();
                        } else {
                            $rootScope.contactNoForIDProof = data.contactNoForIDProof;
                            $rootScope.flowName = data.flowName;
                            redirectService.redirect(data, "ALL");
                        }
                    }
                },
                //if data.errors===true, it will go with the function below.

                function (response) {
                    $scope.showSpinner = false;

                    $scope.autherizationMessage = "";
                    $scope.ssnError = "";
                    $scope.zipCodeError = "";
                    $scope.ssnLastNameError = "";
                    $scope.ssnDateOfBirthError = "";
                    $scope.uniqueidLastNameError = "";
                    $scope.uniqueidDateOfBirthError = "";
                    $scope.streetAddressError = "";

                    if (response.headers("exception") !== null) {
                        $scope.autherizationMessage = response.data.error.code;
                        $scope.autherizationMessageParams = response.data.error.errors[0];
                        $scope.authStatus = response.status;

                        if ($scope.authStatus === 500) {
                            $scope.loginurl = $scope.autherizationMessageParams.errorCode;
                            redirectService.setLoginURL(
                                $scope.loginurl,
                                "Registration Error",
                                "registration"
                            );

                            $state.go("registrationHardStopError");
                        } else if (
                            $scope.authStatus === 401 &&
                            response.data !== null &&
                            $scope.autherizationMessage === "alternative.error.login" &&
                            $scope.autherizationMessageParams !== null
                        ) {
                            $scope.autherizationMessage = "logon." + $scope.autherizationMessage;
                            $scope.accuError = {
                                showDialog: true,
                                redirectAccuUrl: sanitizeURLforRedirection(
                                    $scope.autherizationMessageParams.ALTERNATIVE_LOGN_URL
                                )
                            };
                            $scope.redirectAccuSite();
                        }
                        handleScreenReader("screenReaderAuth");
                    } else {
                        if (
                            response.message !== null &&
                            response.message === "Unexpected token T"
                        ) {
                            $scope.autherizationMessage = "Internal System Error";
                        } else if (
                            response.data !== null &&
                            response.data.error.code === "alternative.error.login" &&
                            response.data.error.errors[0] !== null
                        ) {
                            $scope.autherizationMessage = "logon." + response.data.error.code;
                            $scope.accuError = {
                                showDialog: true,
                                redirectAccuUrl: sanitizeURLforRedirection(
                                    response.data.error.errors[0].ALTERNATIVE_LOGN_URL
                                )
                            };
                            $scope.redirectAccuSite();
                        } else if (response.data !== null || response.data.errors === true) {
                            //console.log("Error Data"    +   error.data) ;
                            $scope.ssnError = response.data.ssn;
                            $scope.zipCodeError = response.data.zipcode;
                            $scope.streetAddressError = response.data.streetAddress;
                            if ($scope.individual.identifierType === "ssn") {
                                $scope.ssnLastNameError = response.data.lastName;
                                $scope.ssnDateOfBirthError = response.data.dateOfBirth;
                            }
                            if ($scope.individual.identifierType === "uniqueid") {
                                $scope.uniqueidLastNameError = response.data.lastName;
                                $scope.uniqueidDateOfBirthError = response.data.dateOfBirth;
                            }
                        } else if (response.appleunauthorized !== null) {
                            $state.go("login");
                        }
                    }
                }
            );
        } else {
            // Some input is not valid, so we need to prompt the participant to fix the issue
            // Manually set the $dirty flag for each input in the form to trigger validation
            if ($scope.individual.identifierType === "ssn") {
                $scope.registerForm.ssnLastName.$setDirty();
                $scope.registerForm.ssnDateOfBirth.$setDirty();
                $scope.registerForm.zipCode.$setDirty();
                $scope.registerForm.zipCode.$setDirty();
            }
            if ($scope.individual.identifierType === "uniqueid") {
                $scope.registerForm.uniqueidLastName.$setDirty();
                $scope.registerForm.uniqueidDateOfBirth.$setDirty();
                $scope.registerForm.uniqueIdentifier.$setDirty();
                $scope.registerForm.planID.$setDirty();
                $scope.registerForm.uniqueIdentifier.$setDirty();
                $scope.registerForm.planID.$setDirty();
            }

            if ($scope.registerForm.ssn) {
                $scope.registerForm.ssn.$setDirty();
            } else {
                $scope.registerForm.ssnM.$setDirty();
            }

            // Handle screen reader accessibility
            handleScreenReader("screenReader");
        }
    };
    // focus the error messages
    var handleScreenReader = function (id) {
        AccessibilityUtil.focusElement(id);
    };
    // focus the input with an error
    $scope.focusOnErrorInput = function (e, elementId) {
        AccessibilityUtil.focusOnErrorInput(e, elementId);
    };
    // focus on the first error in the screen reader error block
    $scope.enableScreenReaderErrors = function (e) {
        AccessibilityUtil.enableScreenReaderErrors(e);
    };
    $scope.registerWithPin = function (individual) {
        eventBus.dispatch(registrationEvents.SUBMIT_PIN, this);
        // Check if the form input is valid
        if ($scope.registerForm.$valid) {
            $scope.showSpinner = true;
            // Everything is good, we can continue with registration
            $rootScope.flowName = "registrationFlow";
            var registerData = {
                ssn: newSSN,
                pin: $scope.individual.pin,
                flowName: $rootScope.flowName,
                isIDProofing: $scope.content.idProofingEnabled,
                accu: $cookies.get("accu")
            };

            registrationFactory.registerWithPin.query(
                registerData,

                function (data, headers) {
                    $scope.showSpinner = false;
                    //console.log ("Success :  "   + data) ;
                    if (data.errors === false) {
                        // $state.go('accountSetup');
                        redirectService.redirect(data, "ALL");
                    }
                },
                function (response) {
                    $scope.showSpinner = false;
                    $scope.autherizationMessage = "";
                    $scope.autherizationMessageParams = "";
                    $scope.ssnError = "";
                    $scope.pinCodeError = "";
                    if (response.headers("exception") !== null) {
                        $scope.autherizationMessage = response.data.error.code;
                        $scope.autherizationMessageParams = response.data.error.errors[0];
                        $scope.authStatus = response.status;
                        if ($scope.authStatus === 500) {
                            $scope.loginurl = $scope.autherizationMessageParams.errorCode;
                            redirectService.setLoginURL(
                                $scope.loginurl,
                                "Registration Error",
                                "registration"
                            );
                            $state.go("registrationHardStopError");
                        } else if (
                            $scope.authStatus === 401 &&
                            response.data !== null &&
                            $scope.autherizationMessage === "alternative.error.login" &&
                            $scope.autherizationMessageParams !== null
                        ) {
                            $scope.autherizationMessage = "logon." + $scope.autherizationMessage;
                            $scope.accuError = {
                                showDialog: true,
                                redirectAccuUrl: sanitizeURLforRedirection(
                                    $scope.autherizationMessageParams.ALTERNATIVE_LOGN_URL
                                )
                            };
                            $scope.redirectAccuSite();
                        }
                        handleScreenReader("screenReaderAuth");
                    } else {
                        if (
                            response.message !== null &&
                            response.message === "Unexpected token T"
                        ) {
                            $scope.autherizationMessage = "Internal System Error";
                        } else if (
                            response.data !== null &&
                            response.data.error.code === "alternative.error.login" &&
                            response.data.error.errors[0] !== null
                        ) {
                            $scope.autherizationMessage = "logon." + response.data.error.code;
                            $scope.accuError = {
                                showDialog: true,
                                redirectAccuUrl: sanitizeURLforRedirection(
                                    response.data.error.errors[0].ALTERNATIVE_LOGN_URL
                                )
                            };
                            $scope.redirectAccuSite();
                        } else if (response.data !== null) {
                            $scope.ssnError = response.data.ssn;
                            $scope.pinError = response.data.pin;
                        }
                    }
                }
            );
        } else {
            // Some input is not valid, so we need to prompt the participant to fix the issue

            // Manually set the $dirty flag for each input in the form to trigger validation
            $scope.registerForm.pin.$dirty = true;
            if ($scope.mobileDevice === "true") {
                $scope.registerForm.ssnM.$dirty = true;
            } else {
                $scope.registerForm.ssn.$dirty = true;
                $scope.registerForm.ssn.$dirty = true;
            }
            // Handle screen reader accessibility
            handleScreenReader("screenReader");
        }
    };
    $scope.idProofWithPin = function (individual) {
        eventBus.dispatch(registrationEvents.SUBMIT_IDPROOF_PIN, this);
        // Check if the form input is valid
        if ($scope.registerForm.$valid) {
            $scope.showSpinner = true;
            // Everything is good, we can continue with registration
            $rootScope.flowName = "registrationFlow";
            var registerData = {
                pin: $scope.individual.pin,
                flowName: $rootScope.flowName,
                accu: $cookies.get("accu"),
                isIDProofing: $scope.content.idProofingEnabled
            };

            registrationFactory.idProofPinAPi.query(
                registerData,

                function (data, headers) {
                    $scope.showSpinner = false;
                    //console.log ("Success :  "   + data) ;
                    if (data.errors === false) {
                        // $state.go('accountSetup');
                        redirectService.redirect(data, "ALL");
                    }
                },
                function (response) {
                    $scope.showSpinner = false;
                    $scope.autherizationMessage = "";
                    $scope.autherizationMessageParams = "";
                    $scope.ssnError = "";
                    $scope.pinCodeError = "";
                    if (response.headers("exception") !== null) {
                        $scope.autherizationMessage = response.data.error.code;
                        $scope.autherizationMessageParams = response.data.error.errors[0];
                        $scope.authStatus = response.status;
                        if ($scope.authStatus === 500) {
                            $scope.loginurl = $scope.autherizationMessageParams.errorCode;
                            redirectService.setLoginURL(
                                $scope.loginurl,
                                "Registration Error",
                                "registration"
                            );
                            $state.go("registrationHardStopError");
                        }
                        handleScreenReader("screenReaderAuth");
                    } else {
                        if (
                            response.message !== null &&
                            response.message === "Unexpected token T"
                        ) {
                            $scope.autherizationMessage = "Internal System Error";
                        } else if (response.data !== null) {
                            $scope.pinError = response.data.pin;
                        }
                    }
                }
            );
        } else {
            // Some input is not valid, so we need to prompt the participant to fix the issue

            // Manually set the $dirty flag for each input in the form to trigger validation
            $scope.registerForm.pin.$dirty = true;
            if ($scope.mobileDevice === "true") {
                $scope.registerForm.ssnM.$dirty = true;
            } else {
                $scope.registerForm.ssn.$dirty = true;
                $scope.registerForm.ssn.$dirty = true;
            }
            // Handle screen reader accessibility
            handleScreenReader("screenReader");
        }
    };

    var checkIdentifierType = function () {
        return $rootScope.accuCustomization.showLoginSetupRecoveryRadio ? "uniqueid" : "ssn";
    };
    var openConsentModal = function () {
        modalInstance = $modal.open({
            template: idProofConsentTemplate,
            controller: IDProofConsentController,
            controllerAs: "idProofConsentCtrl",
            size: "md",
            windowClass: "modal-wrapper"
        });
    };
    var otpService = $injector.get("otpService");
    $scope.openOTPNoCodeModalModal = otpService.openOTPNoCodeModalModal;
    $scope.handleFocusInput = function (event) {
        event.currentTarget.type = "text";
    };
    $scope.handleBlurInput = function (event) {
        event.currentTarget.type = "password";
    };
    $scope.identifierTypeChange = function () {
        eventBus.dispatch(registrationEvents.ID_TYPE_CHANGE, this);
    };
    $scope.ssnInputChange = function () {
        eventBus.dispatch(registrationEvents.SSN_CHANGE, this);
    };
    $scope.zipChange = function () {
        eventBus.dispatch(registrationEvents.ZIP_CHANGE, this);
    };
    $scope.lastNameChange = function () {
        eventBus.dispatch(registrationEvents.LAST_NAME_CHANGE, this);
    };
    $scope.dobChange = function () {
        eventBus.dispatch(registrationEvents.DOB_CHANGE, this);
    };
    $scope.uniqueIdentifierChange = function () {
        eventBus.dispatch(registrationEvents.UNIQUE_ID_CHANGE, this);
    };
    $scope.uniqueIdentifierTooltipSelect = function () {
        eventBus.dispatch(registrationEvents.UNIQUE_ID_TOOLTIP_SELECT, this);
    };
    $scope.planIDChange = function () {
        eventBus.dispatch(registrationEvents.PLAN_ID_CHANGE, this);
    };
    $scope.streetChange = function () {
        eventBus.dispatch(registrationEvents.STREET_CHANGE, this);
    };
    $scope.submitClick = function (source) {
        eventBus.dispatch(registrationEvents.SUBMIT, this, {
            source: source
        });
    };
    $scope.registerNoPin = function (source) {
        eventBus.dispatch(registrationEvents.REGISTRATION_NO_PIN, this, {
            source: source
        });
    };
    $scope.registerPin = function (source) {
        eventBus.dispatch(registrationEvents.REGISTRATION_PIN, this, {
            source: source
        });
    };
    $scope.registerGroup = function (source) {
        eventBus.dispatch(registrationEvents.REGISTRATION_GROUP, this, {
            source: source
        });
    };
    $scope.ssnChangePin = function () {
        eventBus.dispatch(registrationEvents.SSN_CHANGE_PIN, this);
    };
    $scope.pinChange = function () {
        eventBus.dispatch(registrationEvents.PIN_CHANGE, this);
    };
    $scope.getMinimumDateOfBirth = function () {
        return dateUtil.getMinimumDateOfBirth();
    };
    /**
     * determine the validation error (style) class.
     * different class if one error vs multiples.
     */
    $scope.getValidationErrorClass = function (fieldName) {
        var method = "getValidationErrorClass(" + fieldName + ") ";

        logger.debug("{0} starting", [method]);
        var styleName = "rule-validations";

        if (
            _.isUndefined($scope.registerForm) ||
            !fieldName ||
            _.isUndefined($scope.registerForm[fieldName])
        ) {
            logger.debug("{0} form element not found. returning [{1}]", [method, styleName]);
            return styleName;
        }

        var errs = $scope.registerForm[fieldName].$error;
        if (errs) {
            logger.debug("{0} errs={1}", [method, JSON.stringify(errs)]);

            var errorKeys = _.keys(errs);
            logger.debug("{0} errorKeys={1}", [method, JSON.stringify(errorKeys)]);

            //special case, no messaging is defined for pin "pattern" errors.
            //so removing it from the list to avoid false ">1" logic check.
            if (fieldName === "pin") {
                _.pull(errorKeys, "pattern");
            }

            var errorCnt = errorKeys.length;
            logger.debug("{0} errCnt={1}", [method, errorCnt]);

            //if >1 errors, the style class should be bulleted.
            if (errorCnt > 1) {
                styleName = "form-validation-rule";
            }

            logger.debug("{0} returning [{2}]", [method, styleName]);
        }

        return styleName;
    };
    $scope.redirectAccuSite = function () {
        $scope.dialogAccuErrorTimer = $timeout(function () {
            $scope.accuError.showDialog = false;
            window.location.replace($scope.accuError.redirectAccuUrl);
        }, 30000);
    };
    $scope.handleMaskSSN = (event) => {
        const method = "handleMaskSSN()";
        const SSN = $scope.registerForm.ssn.$viewValue;
        const SSNPattern = /^\d{3}-\d{2}-\d{4}/;

        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);

        if (SSN === "" && !_.isUndefined(previousSSN)) {
            if (MaskUtil.isMasked(previousSSN)) {
                $scope.individual.ssn = previousSSN;
                newSSN = null;
            } else {
                $scope.individual.ssn = MaskUtil.maskSSN(previousSSN);
            }
        }

        if (SSNPattern.test(SSN)) {
            newSSN = SSN.replace(/-/g, "");
            $scope.individual.ssn = MaskUtil.maskSSN(SSN);
        } else {
            logger.debug("{0} - ssn is not valid pattern", [method]);
        }

        logger.debug("{0} - exiting handleMaskSSN", [method]);
    };
    $scope.toggleSSNfromMaskedClick = (event) => {
        const method = "toggleSSNfromMaskedClick()";

        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);

        if (!event) {
            logger.debug("{0} - no event.", [method]);
            return;
        }

        if (event.type === "touchend") {
            logger.debug("{0} - ignoring superfluous 'touchend'.", [method]);
            return;
        }

        $scope.focusInput(event);

        if ($scope.isSSNMasked($scope.individual.ssn)) {
            previousSSN = newSSN ? newSSN : $scope.individual.ssn;
            $scope.individual.ssn = "";
        }
    };
    $scope.focusInput = (event) => {
        const method = "focusInput()";

        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);

        $timeout(() => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }, 500);
    };

    $scope.isSSNMasked = (SSN) => {
        return MaskUtil.isMasked(SSN);
    };

    $scope.toggleSSNfromMaskedKeyDown = (event) => {
        if (!$scope.isNavigationKey(event.keyCode)) {
            if ($scope.isSSNMasked($scope.individual.ssn)) {
                const charCode = String.fromCharCode(event.keyCode);

                previousSSN = newSSN ? newSSN : $scope.individual.ssn;
                $scope.individual.ssn = _.isNumber(charCode) ? charCode : "";
            }
        }
    };

    $scope.isNavigationKey = (keyCode) => {
        return keyCode && (keyCode === 9 || keyCode === 16 || (keyCode >= 35 && keyCode <= 40));
    };

    $scope.touchDateOfBirth = (event) => {
        const method = "touchDateOfBirth()";

        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
    };

    $scope.toggleDateOfBirthFromClick = (event) => {
        const method = "toggleDateOfBirthFromClick()";
        const targetName = event.target.name;
        const dateOfBirth = $scope.registerForm[targetName].$viewValue;

        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);

        if (!event) {
            logger.debug("{0} - no event.", [method]);
            return;
        }
        if (event.type === "touchend") {
            logger.debug("{0} - ignoring superfluous 'touchend'.", [method]);
            return;
        }

        $scope.focusInput(event);
    };

    $scope.handleMaskDateOfBirth = (event) => {
        const method = "handleMaskDateOfBirth()";
        const targetName = event.target.name;
        const dateOfBirth = $scope.registerForm[targetName].$viewValue;

        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);

        if (dateOfBirth === "" && !_.isUndefined(previousDateOfBirth)) {
            $scope.individual.dateOfBirth = previousDateOfBirth;
            previousDateOfBirth = "";
        }
    };

    $scope.toggleDateOfBirthfromKeyDown = (event) => {
        const dateOfBirth = $scope.registerForm.dateOfBirth.$viewValue;

        if (!$scope.isNavigationKey(event.keyCode)) {
            const charCode = String.fromCharCode(event.keyCode);

            if (
                MaskUtil.isMasked($scope.individual.dateOfBirth) ||
                $scope.registerForm.dateOfBirth.$valid
            ) {
                previousDateOfBirth = dateOfBirth;
                $scope.individual.dateOfBirth = _.isNumber(charCode) ? charCode : "";
            }
        }
    };

    function sanitizeURLforRedirection(url) {
        //pattern
        //if the url comes like www.viacomwealth.com then is going to be updated as http://www.viacomwealth.com
        //if the url comes like bbmretirementplan.com then is going to be updated as http://bbmretirementplan.com
        var patternProtocol = new RegExp(/http(s)?:\/\//);
        url = url.trim();
        if (!patternProtocol.test(url)) {
            url = "http://" + url;
        }
        return url;
    }

    function extractErrorMessageFromRedirection(href) {
        var currentLocation = href;
        if (currentLocation.indexOf("errorMessage") !== -1) {
            var startParametersIndex = currentLocation.indexOf("?");
            var searchParams = new URLSearchParams(
                currentLocation.substring(startParametersIndex, currentLocation.length)
            );
            $scope.autherizationMessage = $rootScope.errorMessage.code;
            $scope.autherizationMessageParams = $rootScope.errorMessage;
        }
    }
};

registrationController.$inject = [
    "$injector",
    "$modal",
    "$cookies",
    "$rootScope",
    "$scope",
    "$state",
    "$stateParams",
    "$timeout",
    "$translate",
    "AccuCodeService",
    "AuthenticationStatusService",
    "LogoutService",
    "MenuNavigationFactory",
    "SetACCUService",
    "eventBus",
    "redirectService",
    "registrationFactory"
];
export default registrationController;
